import { Component, OnInit, OnDestroy, Input, AfterViewInit, Output, EventEmitter, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { UserSessionService } from '../shared/service/user-session.service';
import { CmHelp, CmSection, ContentType } from '../shared/model/cm/managed-content.model';
import { UntypedFormGroup, Validators, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Notice } from '../shared/model/session/notice'
import { MhsService } from '../shared/service/mhs.service';
import { AuthGuardService } from '../shared/service/auth-guard.service';
import { of } from 'rxjs';
import { AppInsightsApiService } from '../shared/service/app-insights-api.service';
import { ViewportScroller } from '@angular/common';
import { ApplicationService } from '../shared/service/application.service';
import { MhsApplicationResponse } from '../shared/model/mhs-application';
import { COMPANY_ID } from '../shared/global-constants';
import { AppInsightsLoggerService } from '../shared/service/app-insights-logger.service';
import { WindowRef } from '../shared/service/window.service';
import { ModalService } from '../shared/service/modal.service';
import { FormUtils } from '../shared/helper/form-utils';
import { CmDialog } from '../shared/model/cm-dialog';
import { GoogleAnalyticsService } from '../shared/service/google-analytics.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { PartialSaveService } from '../shared/service/partial-save.service';
import { environment } from '@environment';

@Component({
  selector: 'app-auth-sign',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './auth-sign.component.html',
  styleUrls: ['./auth-sign.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthSignComponent implements OnInit, AfterViewInit, OnDestroy {
    @Output() cancelEmitter = new EventEmitter<void>();
    @Output() backEmitter = new EventEmitter<void>();
    @Output() val = new EventEmitter<boolean>();
    @Input() showBackButton: boolean = false;

    public environmentName: string;

    private systemError: CmHelp = this.cmService.getContentById(ContentType.HELP, "system-error");
    private cancelContent: CmHelp = this.cmService.getContentById(ContentType.HELP, "lose-data-warning");
    public modalContentHeading: string = this.cancelContent.title;
    public modalContentBody: string = FormUtils.sanitize(this.cancelContent.body);
    public hasFraudNotice: boolean;
    errorModalDialogContent: CmDialog;
    errorModalContent: Notice;
    checkboxFormValid: boolean = true;
    public authSignEnd: string;
    public hasBenefitDisclaimer: boolean;
    public noticeModals: string[] = ['notice','fraud','release','info', 'benefit-disclaimer'];
    public formNumber: string = this.userSessionService.data.formNumber;
    public isGenericDynamicForm: boolean = this.userSessionService.data.isGenericDynamicForm;

    public submitBtnText: string = 'Submit Statement';

    @Input() parentForm: UntypedFormGroup;
    authSignForm : FormGroup;
    authSignSectionFraudText: string;
    authSignSectionReleaseText: string;
    authSignSectionInfoText: string;
    benefitDisclaimerText: string;

    authSignSection: CmSection;
    authSignSectionFraud: CmSection;
    authSignSectionRelease: CmSection;
    benefitDisclaimerInfo: CmSection;
    authSignSectionInfo: CmSection;
    authSignSectionEnd: CmSection;
    authSignSectionFooter: CmSection;
    acknowledgmentSection: CmSection;
    ackAuthModalContentBeginning: Notice;
    acknowledgmentModalContent: Notice;
    authSignElement = this.cmService.getContentById(ContentType.ELEMENT, "authorization-esig");
    authSignBody: string;
    authSignFooter: string;
    acknowledgementText: string;

    notices: Notice[];
    fraudModalContent: Notice;
    ackAuthModalContent: Notice;
    infoModalContent: Notice;
    benefitDisclaimerModalContent: Notice;

    formSubmitted: boolean;
    spinnerSubmit: boolean = false;
    isSYN: boolean = false;
    isNmNewYork: boolean = false;

    backButtonDialogContent: CmDialog = {
        id: "backModal",
        heading: this.modalContentHeading,
        body: this.modalContentBody,
        size: "medium",
    };

    fraudModalDialogContent: CmDialog;
    ackModalDialogContent: CmDialog;
    infoModalDialogContent: CmDialog;
    benefitDisclaimerDialogContent: CmDialog;

    // GA4 Custom events
    public submitAuthSign = {
        action: "button_click",
        category: "auth-sign",
        name: "submit",
    }

    public cancelAuthSign = {
        action: "button_click",
        category: "auth-sign",
        name: "cancel",
    }

    public consent: string;

    constructor(private router: Router,
                private cmService: ManagedContentService,
                private userSessionService: UserSessionService,
                private googleAnalyticsService: GoogleAnalyticsService,
                private mhsService: MhsService,
                private authGuardService: AuthGuardService,
                private appInsightsApiService: AppInsightsApiService,
                private scroller: ViewportScroller,
                private applicationService: ApplicationService,
                private appInsightsLoggerService: AppInsightsLoggerService,
                private modalService: ModalService,
                private windowService: WindowRef,
                public formControlUtilitiesService: FormControlUtilitiesService,
                private cdr: ChangeDetectorRef,
                private el: ElementRef,
                private partialSaveService: PartialSaveService
                ) {
    }

    ngOnInit(): void {
        if(this.userSessionService.data.sessionEnded){
            this.router.navigate(['/instructions']);
        }

        this.environmentName = environment.name;

        this.authSignSection = this.cmService.getContentById(ContentType.SECTION, "authorization-esig-section");
        this.authSignSectionFraud = this.cmService.getContentById(ContentType.SECTION, "authorization-esig-section-fraud");
        this.benefitDisclaimerInfo = this.cmService.getContentById(ContentType.SECTION, "authorization-benefit-disclaimer-text");
        this.authSignSectionRelease = this.cmService.getContentById(ContentType.SECTION, "authorization-esig-section-release");
        this.authSignSectionInfo = this.cmService.getContentById(ContentType.SECTION, "authorization-esig-section-info");
        this.authSignSectionEnd = this.cmService.getContentById(ContentType.SECTION, "authorization-esig-section-end");
        this.acknowledgmentSection = this.cmService.getContentById(ContentType.SECTION, "acknowledgement-esig-section");

        if(this.userSessionService.data.formNumber === "91-18637"){
            this.authSignSectionFooter = this.cmService.getContentById(ContentType.SECTION, "authorization-esig-section-footer");
            this.authSignFooter = this.authSignSectionFooter.body;
        }

        if(this.isGenericDynamicForm){
          this.submitBtnText = 'Next';
        }

        this.authSignSectionFraudText = this.authSignSectionFraud.body.replace(/\n/g, '').replace('<p>', '').replace('&nbsp;', '').replace('</p>', '');
        this.authSignSectionInfoText = this.authSignSectionInfo.body.replace(/\n/g, '');
        this.authSignSectionInfoText = this.authSignSectionInfo.body.replace('<p>', '');
        this.authSignSectionInfoText = this.authSignSectionInfoText.replace('&nbsp;', '');
        this.authSignSectionInfoText = this.authSignSectionInfoText.replace('</p>', '');
        this.authSignSectionReleaseText = this.authSignSectionRelease.body.replace(/\n/g, '');
        this.authSignSectionReleaseText = this.authSignSectionRelease.body.replace('<p>', '');
        this.authSignSectionReleaseText = this.authSignSectionReleaseText.replace('&nbsp;', '');
        this.authSignSectionReleaseText = this.authSignSectionReleaseText.replace('</p>', '');
        this.acknowledgementText = this.acknowledgmentSection.body.replace(/\n/g, '');
        this.acknowledgementText = this.acknowledgmentSection.body.replace('<p>', '');
        this.acknowledgementText = this.acknowledgementText.replace('&nbsp;', '');
        this.acknowledgementText = this.acknowledgementText.replace('</p>', '');
        this.benefitDisclaimerText = this.benefitDisclaimerInfo.body.replace(/\n/g, '');
        this.benefitDisclaimerText = this.benefitDisclaimerInfo.body.replace('<p>', '');
        this.benefitDisclaimerText = this.benefitDisclaimerText.replace('&nbsp;', '');
        this.benefitDisclaimerText = this.benefitDisclaimerText.replace('</p>', '');

        this.authSignBody = this.authSignSection.body;
        this.authSignEnd = FormUtils.sanitize(this.authSignSectionEnd.body);

        this.notices = this.userSessionService.data.notices;

        this.formSubmitted = false;

        this.hasFraudNotice = this.userSessionService.data.hasFraudNotice;

        this.isSYN = this.userSessionService.data.companyId == 'YI';

        if(this.userSessionService.data.formNumber === "25235" && this.userSessionService.data.companyId === COMPANY_ID.NM){
          this.isNmNewYork = true;
        } else {
          this.isNmNewYork = false;
        }

        if(this.notices) {
            this.fraudModalContent = this.notices["fraudNotices"];
            this.ackAuthModalContent = this.notices["authAck"];
            this.infoModalContent = this.notices["infoPractices"];
            this.benefitDisclaimerModalContent =  this.notices["benefitDisclaimer"];

            if(this.isGenericDynamicForm){
              this.ackAuthModalContentBeginning = this.notices["authAck"];
              this.acknowledgmentModalContent = this.notices["acknowledgement"];
            } else {
              this.ackAuthModalContent = this.notices["authAck"];
            }

            if(this.benefitDisclaimerModalContent){
              this.hasBenefitDisclaimer = true;
              this.benefitDisclaimerDialogContent = {
                id: "disclaimerModel",
                heading: this.benefitDisclaimerModalContent.title,
                body: this.benefitDisclaimerModalContent.body,
                size: "large",
              };
            }

            if(this.fraudModalContent){
                this.fraudModalDialogContent = {
                    id: "fraudModal",
                    heading: this.fraudModalContent.title,
                    body: this.fraudModalContent.body,
                    size: "large",
                };
            }

            if(this.ackAuthModalContent){
                this.ackModalDialogContent = {
                    id: "ackModal",
                    heading: this.ackAuthModalContent.title,
                    body: this.ackAuthModalContent.body,
                    size: "large",
                }
            }

            if(this.infoModalContent){
                this.infoModalDialogContent = {
                    id: "ackModal",
                    heading: this.infoModalContent.title,
                    body: this.infoModalContent.body,
                    size: "large",
                }
            }

        }

        // Check for saved form data in session
        const savedAuthSignData = this.userSessionService.data['authSignFormData'];

        // Check if form already exists in parent (user navigated back to this page)
        if (this.parentForm && this.parentForm.contains('authSign')) {
            // Use existing form to preserve data
            this.authSignForm = this.parentForm.get('authSign') as UntypedFormGroup;
        } else {
            // Create new form for first visit
            this.authSignForm = new FormGroup({
                agreedOrAcknowledged: new FormControl(false, [
                    Validators.requiredTrue
                ]),
            });
        }

        // Add form to parent if it was newly created inside a shared parent form
        const wasNewlyCreated = this.parentForm && !this.parentForm.contains('authSign');
        if (wasNewlyCreated) {
            this.parentForm.addControl('authSign', this.authSignForm);
        }

        // Restore saved data for standalone renders and for newly created shared forms.
        const shouldRestoreSavedData = !!savedAuthSignData && (!this.parentForm || wasNewlyCreated);
        if (shouldRestoreSavedData) {
            // Set values synchronously first to prevent validation flash
            Object.keys(savedAuthSignData).forEach(key => {
                const control = this.authSignForm.get(key);
                if (control && savedAuthSignData[key] !== null && savedAuthSignData[key] !== undefined) {
                    control.setValue(savedAuthSignData[key], { emitEvent: false });
                    // Mark as untouched and pristine immediately to prevent validation errors
                    control.markAsUntouched();
                    control.markAsPristine();
                }
            });
            
            setTimeout(() => {
                Object.keys(savedAuthSignData).forEach(key => {
                    const control = this.authSignForm.get(key);
                    if (control && savedAuthSignData[key] !== null && savedAuthSignData[key] !== undefined) {
                        control.setValue(savedAuthSignData[key], { emitEvent: true });
                        // Mark as untouched and pristine to prevent validation errors from showing
                        control.markAsUntouched();
                        control.markAsPristine();
                        control.updateValueAndValidity();
                    }
                });
                this.cdr.detectChanges();
                // Force web components to update (checkbox state)
                setTimeout(() => {
                    this.forceCheckboxUpdate();
                }, 50);
            }, 100);
        }

        if(this.userSessionService.data.companyId === COMPANY_ID.NM){
            let systemError = this.cmService.getContentById(ContentType.HELP,"system-error-nm");
            this.errorModalContent = {
              id: systemError.id,
              title: systemError.title,
              body: systemError.body
            };
          } else {
            let systemError = this.cmService.getContentById(ContentType.HELP,"system-error");
            this.errorModalContent = {
              id: systemError.id,
              title: systemError.title,
              body: systemError.body
            };
          }

        if(this.errorModalContent){
            this.errorModalDialogContent = {
              id: "errorModal",
              heading: this.errorModalContent.title,
              body: this.errorModalContent.body,
              size: "medium",
          };
        }

        // Subscribe to resubmit requests from progress bar navigation
        this.mhsService.submitAuthSign.subscribe(shouldTriggerValidation => {
          if (shouldTriggerValidation) {
            // Mark all form controls as touched to show validation errors
            Object.keys(this.authSignForm.controls).forEach(key => {
              const control = this.authSignForm.get(key);
              control?.markAsTouched();
              control?.markAsDirty();
              control?.updateValueAndValidity();
            });
            // Trigger change detection to update UI
            this.cdr.detectChanges();
            
            // Reset the trigger after processing
            setTimeout(() => {
              this.mhsService.resubmitAuthSign(false);
            }, 100);
          }
        });

        if(this.windowService){
          this.windowService.nativeDocument
          .querySelector('body')
          .addEventListener('click', (event: Event) => this.onClick(event));
        }
    }//end ngOnInit

    ngAfterViewInit() {
        this.appInsightsApiService.endNavigationEvent(this.router.url);
    }

    ngOnDestroy() {
        // Save form data to session before component is destroyed
        if (this.authSignForm) {
            const formValue = this.authSignForm.value;
            const hasData = Object.values(formValue).some(value => 
                value !== null && value !== undefined && value !== ''
            );
            
            if (hasData) {
                this.userSessionService.data['authSignFormData'] = formValue;
            }
        }
    }

    get agreedOrAcknowledged() { return this.authSignForm.get("agreedOrAcknowledged");}

    public fraudButtonProps = {
        keyId: 'fraud-notice-button',
        size: 'large',
        text: 'Fraud Notice.',
        type: 'click',
        variant: 'text'
    }

    public infoPracticesButtonProps = {
        keyId: 'info-notice-button',
        size: 'large',
        text: 'Information Practices Notice.',
        type: 'click',
        variant: 'text'
    }

    public disclaimerButtonProps = {
        keyId: 'benefit-disclaimer-button',
        size: 'large',
        text: 'Accelerated Death Benefit Disclaimer.',
        type: 'click',
        variant: 'text'
      }

    public releaseButtonProps = {
        keyId: 'release-button',
        size: 'large',
        text: 'Acknowledgement and Authorization for Release of Information.',
        type: 'click',
        variant: 'text'
    }

    onFraud(){
      this.modalContentHeading = this.fraudModalContent.title;
      this.modalContentBody = this.fraudModalContent.body;

      this.modalService.showModal('prism-ui-modal-fraud-modal'); // Use the service to show the modal
    }

    onRelease(){
      this.modalContentHeading = this.ackAuthModalContent.title;
      this.modalContentBody = this.ackAuthModalContent.body;

      this.modalService.showModal('prism-ui-modal-release-modal'); // Use the service to show the modal
    }

    onInfo(){
      this.modalContentHeading = this.infoModalContent.title;
      this.modalContentBody = this.infoModalContent.body;

      this.modalService.showModal('prism-ui-modal-info-modal'); // Use the service to show the modal
    }

    onBenefitDisclaimer(){
      this.modalContentHeading = this.benefitDisclaimerModalContent.title;
      this.modalContentBody = this.benefitDisclaimerModalContent.body;

      this.modalService.showModal('prism-ui-modal-benefit-disclaimer-modal'); // Use the service to show the modal
    }

    onAcknowledgment(){
      this.modalContentHeading = this.acknowledgmentModalContent.title;
      this.modalContentBody = this.acknowledgmentModalContent.body;

      this.modalService.showModal('prism-ui-modal-notice-modal'); // Use the service to show the modal
    }

    onAuthPartOne(){
      this.modalContentHeading = this.ackAuthModalContentBeginning.title;
      this.modalContentBody = this.ackAuthModalContentBeginning.body;

      this.modalService.showModal('prism-ui-modal-notice-modal'); // Use the service to show the modal
    }

    public onCancel(){
      this.cancelEmitter.emit();
    }

    public onBack(){
      this.backEmitter.emit();
    }

    private forceCheckboxUpdate() {
      // Force prism-ui-checkbox to reflect the restored checked state
      const checkboxes = document.querySelectorAll('prism-ui-checkbox');
      checkboxes.forEach((checkbox: any) => {
        const formControlName = checkbox.getAttribute('formControlName');
        if (formControlName) {
          const control = this.authSignForm.get(formControlName);
          if (control && control.value === true) {
            checkbox.setAttribute('checked', 'true');
            checkbox.checked = true;
            
            // Also try setting the inner input if shadow DOM is used
            if (checkbox.shadowRoot) {
              const innerInput = checkbox.shadowRoot.querySelector('input[type="checkbox"]');
              if (innerInput) {
                innerInput.checked = true;
              }
            }
          }
        }
      });
    }

    async onSubmit(): Promise<void>{
      //check that we aren't in maintenance mode

      //do not check for the maintenance mode if we are running locally
      if(window.location.href.startsWith("http://localhost")){
        this.submitForm();
      } else {
        let result = await this.userSessionService.checkForSystemMaintenance();
        if(!result){//the above call will return "true" if we are in maintenance mode
          this.submitForm();
        }
      }
    }

    submitForm(){
      if(this.environmentName === 'demonstration'){
        this.SubmitFormDemoMode();
      } else {
        this.submitPartialForm();
      }
    }

    public SubmitFormDemoMode(){
      this.googleAnalyticsService.sendCustomEvent(this.submitAuthSign);
      this.authSignForm.markAllAsTouched();
      if(this.authSignForm.valid){
        if(this.isGenericDynamicForm){
          this.formSubmitted = true; // Allow navigation to next step
          this.val.emit(true);
          return;
        }

        this.userSessionService.data.mhsApplication.agreedOrAcknowledged = "true";
        this.formSubmitted = true;
        this.spinnerSubmit = true;

        //NOTE: DEMO MODE DOES NOT GENERATE A PDF

        this.userSessionService.data.submitDate = new Date();

        this.formSubmitted = true;

        //cleanup
        this.mhsService.updateSubmission(false);
        this.mhsService.resubmitEmployeeInfo(false);
        this.mhsService.resubmitApplicantInfo(false);
        this.mhsService.resubmitPhysician(false);
        this.mhsService.resubmitAuthSign(false);
        this.mhsService.resubmitMedicalHistory(false);
        this.mhsService.physicianErrorThrown = false;
        this.mhsService.updateThrowPhysicianError(false);
        
        this.val.emit(this.formSubmitted);

      } else {
          this.formSubmitted = false;
          this.spinnerSubmit = false;
      }
    }

    public submitPartialForm(){
      this.googleAnalyticsService.sendCustomEvent(this.submitAuthSign);
      this.authSignForm.markAllAsTouched();
      const spinnerStartTime = new Date().getTime();
      if(this.authSignForm.valid){
        if(this.isGenericDynamicForm){
          this.formSubmitted = true;
          const spinnerStartTime = new Date().getTime();
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Started.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
          this.userSessionService.data.mhsApplication.agreedOrAcknowledged = "true";
          this.partialSaveService.updateAcknowledgements();
          this.val.emit(true);
          this.formSubmitted = false;
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
          const spinnerStopTime = new Date().getTime();
          const spinnerDuration = spinnerStopTime - spinnerStartTime;
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
          return;
        }

        this.userSessionService.data.mhsApplication.agreedOrAcknowledged = "true";
        this.userSessionService.data.mhsApplication.mhsId = this.userSessionService.data.mhsId;
        this.partialSaveService.updateAcknowledgements();
        this.formSubmitted = true;
        const spinnerStartTime = new Date().getTime();
        this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Started.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
        this.spinnerSubmit = true;

        this.applicationService.submitCloudApplication(this.userSessionService.data.formNumber, this.userSessionService.data.mhsApplication)
        .subscribe((response: MhsApplicationResponse) => {
          this.spinnerSubmit = true;
          if(response === undefined || response === null) {
            this.appInsightsLoggerService.log('info', 'An error occurred while generating the PDF.  Either the MHS ID or the PDF is in invalid.  User got the Something Went Wrong message. mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
            this.raiseSomethingWentWrongModal(spinnerStartTime);
            return;
          } else {
            if(response.pdfId === undefined || response.pdfId === null || response.pdfId === '') {
              this.appInsightsLoggerService.log('info', 'An error occurred while generating the PDF.  User got the Something Went Wrong message. mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
              this.raiseSomethingWentWrongModal(spinnerStartTime);
              return;
            }
          }

          this.userSessionService.data.mhsId = response.mhsId;
          this.userSessionService.data.pdfId = response.pdfId;
          this.userSessionService.data.submitDate = new Date();

          this.partialSaveService.updateFlowStatusToReady();

          //cleanup
          this.mhsService.updateSubmission(false);
          this.mhsService.resubmitEmployeeInfo(false);
          this.mhsService.resubmitApplicantInfo(false);
          this.mhsService.resubmitPhysician(false);
          this.mhsService.resubmitAuthSign(false);
          this.mhsService.resubmitMedicalHistory(false);
          this.mhsService.physicianErrorThrown = false;
          this.mhsService.updateThrowPhysicianError(false);
          
          // Track this submission (for states without electronic-communication step)
          const submissionId = this.userSessionService.data.getSubmissionIdentifier();
          if (!this.userSessionService.data.submittedApplicantTypes) {
            this.userSessionService.data.submittedApplicantTypes = [];
          }
          if (!this.userSessionService.data.submittedApplicantTypes.includes(submissionId)) {
            this.userSessionService.data.submittedApplicantTypes.push(submissionId);
          }
          
          this.val.emit(this.formSubmitted);
          const spinnerStopTime = new Date().getTime();
          const spinnerDuration = spinnerStopTime - spinnerStartTime;
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
          },
        (error: any) => {
          // For local development: ignore PDF generation errors and proceed anyway
          if ((this.environmentName === 'demonstration' || window.location.href.startsWith("http://localhost")) 
              && error?.error?.httpStatusCode === 500 
              && error?.error?.message?.includes('Error generating PDF')) {
            this.appInsightsLoggerService.log('info', 'LOCAL MODE: Ignoring PDF generation error and proceeding to confirmation. mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
            
            // Set mock data and proceed
            this.userSessionService.data.submitDate = new Date();
            this.userSessionService.data.pdfId = 'local-mock-pdf-id';
            
            // Cleanup
            this.mhsService.updateSubmission(false);
            this.mhsService.resubmitEmployeeInfo(false);
            this.mhsService.resubmitApplicantInfo(false);
            this.mhsService.resubmitPhysician(false);
            this.mhsService.resubmitAuthSign(false);
            this.mhsService.resubmitMedicalHistory(false);
            this.mhsService.physicianErrorThrown = false;
            this.mhsService.updateThrowPhysicianError(false);
            
            // Track this submission
            const submissionId = this.userSessionService.data.getSubmissionIdentifier();
            if (!this.userSessionService.data.submittedApplicantTypes) {
              this.userSessionService.data.submittedApplicantTypes = [];
            }
            if (!this.userSessionService.data.submittedApplicantTypes.includes(submissionId)) {
              this.userSessionService.data.submittedApplicantTypes.push(submissionId);
            }
            
            this.val.emit(true);
            this.spinnerSubmit = false;
            return;
          }
          
          // Normal error handling for non-local or other errors
          this.appInsightsLoggerService.log('error', 'Error log from Mhs.component', JSON.stringify(error));
          this.formSubmitted = false;
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
          const spinnerStopTime = new Date().getTime();
          const spinnerDuration = spinnerStopTime - spinnerStartTime;
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');

          this.modalContentHeading = this.systemError.title;
          this.modalContentBody = FormUtils.sanitize(this.errorModalDialogContent.body);

          this.modalService.showModal('prism-ui-modal-notice-modal'); // Use the service to show the modal

          this.spinnerSubmit = false;
        });

      } else {
          // Scroll to first invalid control
          const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
            "form .ng-invalid"
          );
          if (firstInvalidControl) {
            FormUtils.scrollToFirstInvalidControl(firstInvalidControl);
          }
          
          this.formSubmitted = false;
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
          this.spinnerSubmit = false;
          const spinnerStopTime = new Date().getTime();
          const spinnerDuration = spinnerStopTime - spinnerStartTime;
          this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
      }
    }

    raiseSomethingWentWrongModal(spinnerStartTime: number){
      this.formSubmitted = false;
      this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Stopped.' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');
      const spinnerStopTime = new Date().getTime();
      const spinnerDuration = spinnerStopTime - spinnerStartTime;
      this.appInsightsLoggerService.log('info', 'Auth Sign Component: Spinner Duration: ' + spinnerDuration + 'ms' + ' mhsId/caseId: ' + this.userSessionService.data.mhsId, '');

      this.modalContentHeading = this.systemError.title;
      this.modalContentBody = FormUtils.sanitize(this.errorModalDialogContent.body);

      this.modalService.showModal('prism-ui-modal-notice-modal'); // Use the service to show the modal
    }

    resetSpinner(){
        this.spinnerSubmit = false;
    }

    leaveAnyway(){
      this.userSessionService.clearSession();
      this.userSessionService.data.sessionEnded = true;
      this.authGuardService.cancelLeaveAnyway();
      this.router.navigate(['/instructions']);
    }

    onCancelModal(modalName: string){
      const modalElement =
        this.windowService.nativeDocument.getElementById(modalName);

      if (modalElement && modalElement.close) {
        modalElement.close();
      } else {
        this.appInsightsLoggerService.log('info', 'Info log from ApplicantType.component', `Modal with id ${modalName} not found or doesn't support close method.`);
      }
    }

    // use the window service to access the modal element
    // and close the modal when the user clicks outside of it
    onClick(event: Event) {
      const modal = this.windowService.nativeDocument.getElementById(
        'prism-ui-modal-cancel-modal'
      );

      if (modal && event.target === modal) {
        this.onCancelModal('prism-ui-modal-cancel-modal');
      }

      this.noticeModals.forEach(noticeItem => {
        const modalItem = this.windowService.nativeDocument.getElementById(
          'prism-ui-modal-'+noticeItem+'-modal'
        );
        if (modalItem && event.target === modalItem) {
          this.onCancelModal('prism-ui-modal-'+noticeItem+'-modal');
        }
      });
    }

    canDeactivate(){
      if (!this.formSubmitted && !this.userSessionService.data.sessionEnded){
        this.modalContentHeading = this.cancelContent.title;
        this.modalContentBody = FormUtils.sanitize(this.cancelContent.body);
        this.modalService.showModal('prism-ui-modal-cancel-modal'); // Use the service to show the modal
        return this.userSessionService.data.sessionEnded;
      } else {
        return of(true);
      }
    }
}
